import { render, staticRenderFns } from "./FixedButtomNavbarCartStatus.vue?vue&type=template&id=9358a022&"
import script from "./FixedButtomNavbarCartStatus.vue?vue&type=script&lang=js&"
export * from "./FixedButtomNavbarCartStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports